import { ReactNode, useEffect } from 'react'

import { AppEvents } from 'src/constants'
import { useLogout } from 'src/hooks'

interface LogoutProviderProps {
  children: ReactNode
}

const LogoutProvider = ({ children }: LogoutProviderProps) => {
  const { logoutWithNavigate } = useLogout()

  useEffect(() => {
    document.addEventListener(AppEvents.APP_LOG_OUT, listenerCallback)

    return () => {
      document.removeEventListener(AppEvents.APP_LOG_OUT, listenerCallback)
    }

    async function listenerCallback() {
      await logoutWithNavigate()
    }
  })

  return <>{children}</>
}

export { LogoutProvider }
